import { UserIcon } from '@backstage/core-components';
import { EntityRefLinks } from '@backstage/plugin-catalog-react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  footer: {
    display: "flex",
    justifyContent: "space-between",
    flex: 1,
    alignItems: "center"
  },
  ownedBy: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    color: theme.palette.link
  },
  actionContainer: { padding: "16px", flex: 1, alignItems: "flex-end" }
}));
const TemplateCardActions = ({
  canCreateTask,
  handleChoose,
  ownedByRelations
}) => {
  const styles = useStyles();
  return /* @__PURE__ */ React.createElement("div", { className: styles.footer, "data-testid": "template-card-actions--footer" }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: styles.ownedBy,
      "data-testid": "template-card-actions--ownedby"
    },
    ownedByRelations.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(UserIcon, { fontSize: "small" }), /* @__PURE__ */ React.createElement(
      EntityRefLinks,
      {
        style: { marginLeft: "8px" },
        entityRefs: ownedByRelations,
        defaultKind: "Group",
        hideIcons: true
      }
    ))
  ), canCreateTask ? /* @__PURE__ */ React.createElement(
    Button,
    {
      size: "small",
      variant: "outlined",
      color: "primary",
      "data-testid": "template-card-actions--create",
      onClick: handleChoose
    },
    "Choose"
  ) : null);
};

export { TemplateCardActions };
//# sourceMappingURL=TemplateCardActions.esm.js.map
